import { Component, EventEmitter, TemplateRef, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { qmsService } from '../qms/qms.service';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { messageService } from '../message.service';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-homepagetag',
  templateUrl: './homepagetag.component.html',
  styleUrls: ['./homepagetag.component.scss']
})
export class HomepagetagComponent {
  @Output() valueEmitter = new EventEmitter<string>();
  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private router: Router, public qmsservice: qmsService, private snackBar: MatSnackBar, public appService: AppService,
    public dialog: MatDialog, public message: messageService
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  dateFormat: any = this.message.organizationDetails?.dateFormat == null ? 'DD-MMM-YYYY' : this.message.organizationDetails?.dateFormat;

  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
  }

  $present_future_config = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  ngOnInit(): void { };
  isProcessing: boolean;
  @ViewChild('tagRecordPopup', { static: true }) tagRecordPopup: TemplateRef<any>;
  visibletagRecordPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  visibleConfirmationPopup: MatDialogRef<TemplateRef<any>>;

  confirmationPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  tagRecordPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };
  labelName: any;
  homepageTagData: any = {};
  openpopup(data: any) {
    this.homepageTagData = {};
    this.homepageTagData.labelName = data.labelName;
    this.homepageTagData.Page = data.pageName;
    this.homepageTagData.tagRef = data.tagRef;
    this.homepageTagData.taskId = data.taskId;
    this.homepageTagData.tagPermanently = false;
    this.homepageTagData.tagTill = null;
    this.labelName = data.labelName;
    //this.reasonForSwitch = null;
    this.visibletagRecordPopup = this.dialog.open(this.tagRecordPopup, this.tagRecordPopupConfig);

    this.tagTillFieldValue = document.getElementById('tagTill-validation') as HTMLInputElement;
    if (this.tagTillFieldValue.style != undefined) { this.tagTillFieldValue.style.color = '#005c8a'; }

    //this.visibleConfirmationPopup = this.dialog.open(this.confirmationPopup, this.confirmationPopupConfig);
  }
  canceltagRecordPopup() {
    this.visibletagRecordPopup.close();
  }
  tagTillFieldValue: any;
  fieldValidation() {
    this.tagTillFieldValue = document.getElementById('tagTill-validation') as HTMLInputElement;
    if (this.homepageTagData.tagPermanently == false && (this.homepageTagData.tagTill == null || this.homepageTagData.tagTill == "")) {
      this.tagTillFieldValue.style.color = 'red';
    } else {
      this.tagTillFieldValue.style.color = '#005c8a';
    }
  }
  executeTagUntag() {
    if (this.homepageTagData.tagPermanently == false && this.homepageTagData.tagTill == null) {
      this.fieldValidation();
      alert("Please enter the mandatory field");
    } else {
      if (this.homepageTagData.tagTill) {
        this.homepageTagData.tagTill = new Date(this.homepageTagData.tagTill);
      } else {
        this.homepageTagData.tagTill = null;
      }
      this.isProcessing = true;
      let data = {

        page: this.homepageTagData.Page,
        module: this.homepageTagData.Page == 'Folder' ? 'DMS' : this.homepageTagData.Page == 'Document' ? 'DMS' : this.homepageTagData.Page == 'FORMS' ? 'FORMS' : this.qmsservice.moduleName,
        taskId: this.homepageTagData.Page == 'Module' ? 0 : this.homepageTagData.Page == 'Detail' ? this.message.activityId : this.homepageTagData.Page == 'Folder' ? this.homepageTagData.taskId : this.homepageTagData.Page == 'Document' ? this.homepageTagData.taskId : this.homepageTagData.Page == 'FORMS' ? this.homepageTagData.taskId : this.homepageTagData.taskId,
        tagRef: this.homepageTagData.tagRef,
        groupId: this.homepageTagData.Page == 'Folder' ? 0 : this.homepageTagData.Page == 'Document' ? 0 : this.homepageTagData.Page == 'FORMS' ? 0 : this.qmsservice.SelectedGroupNameAndValue[0]?.valueExp,
        tagPermanently: this.homepageTagData.tagPermanently ? "Y" : "N",
        tagTill: this.homepageTagData.tagTill,
        operation: this.labelName,
        deleteReason: null
      }

      this.appService.createhomepagetags(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType != "S") {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
            this.valueEmitter.emit();

          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
            this.visibletagRecordPopup.close();
            this.visibleConfirmationPopup?.close();

          }
        },
        error: (error) => { this.isProcessing = false; throw error; }
      });
    }



  }
  closeConfirmationPopup() {
    this.visibleConfirmationPopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe({
      next: () => {
        sb.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { }
    })
  }
}
